/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import digitalGaugeTemplate from './digital-gauge.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import TbCanvasDigitalGauge from "../../../canvas-digital-gauge";

export default angular.module('agrolog.client.digital-gauge', [])
    .directive('agDigitalGauge', DigitalGauge)
    .name;

/*@ngInject*/
function DigitalGauge() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '<',
            targetDataKey: '<',
            targetValue: '<',
            digitalGaugeSettings: '='
        },
        controller: DigitalGaugeController,
        controllerAs: 'vm',
        templateUrl: digitalGaugeTemplate
    }
}
/* eslint-disable angular/angularelement */

/*@ngInject*/
function DigitalGaugeController($scope, $log) {// eslint-disable-line

    let vm = this;

    function createDigitalGauge () {
        if (vm.targetDataKey) {
            var dataObj = {
                dataKey: vm.targetDataKey
            };
            vm.ctx.data = [dataObj];
            vm.ctx.settings = {};
            if (vm.digitalGaugeSettings) {
                angular.merge(vm.ctx.settings, vm.digitalGaugeSettings);
            }
            vm.digitalGauge = new TbCanvasDigitalGauge(vm.ctx, 'digitalGauge');
            vm.digitalGauge.gauge.value = 0;
            vm.digitalGauge.gauge._value = 0;
            vm.digitalGauge.gauge.update({animation: false});
        }
    }

    $scope.$on('createDigitalGauge', () => {
        //$log.info('createDigitalGauge', vm.targetDataKey, vm)
        createDigitalGauge();
    });

    $scope.$watch('vm.targetValue', () => {
        //$log.info('gauge value', vm.targetValue, angular.isDefined(vm.targetValue), vm.digitalGauge)
        if (!vm.digitalGauge) {
            createDigitalGauge();
        }
        if (vm.digitalGauge) {
            //$log.info('has changes', vm.targetValue !== vm.digitalGauge.gauge.value)
        }

        if (angular.isDefined(vm.targetValue) && vm.digitalGauge) {
            if (vm.targetValue !== vm.digitalGauge.gauge.value) {
                vm.digitalGauge.gauge.value = vm.targetValue;
                vm.digitalGauge.gauge._value = vm.targetValue;
                if (vm.ctx.isMobile) {
                    vm.digitalGauge.gauge.update({animation: false});
                }
                vm.digitalGauge.gauge.update({animation: true});
            }
        }
    });

    $scope.$watch('vm.ctx.width + vm.ctx.height', (newValue) => {
        if (vm.digitalGauge && newValue) {
            let gaugeContainer = angular.element('ag-digital-gauge');
            vm.digitalGauge.gauge.update({width: gaugeContainer[0].clientWidth, height: gaugeContainer[0].clientHeight});
        }
    });
}
